"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ReducerRegistry {
    getReducers() {
        return this.reducers;
    }
    register(name, reducer) {
        this.reducers = Object.assign(Object.assign({}, this.reducers), { [name]: reducer });
        if (this.emitChange) {
            this.emitChange(this.reducers);
        }
    }
    unregister(name) {
        const reducers = Object.assign({}, this.reducers);
        delete reducers[name];
        this.reducers = reducers;
        if (this.emitChange) {
            this.emitChange(this.reducers);
        }
    }
    setChangeListener(listner) {
        this.emitChange = listner;
    }
}
const reducerRegistry = new ReducerRegistry();
exports.default = reducerRegistry;
